import { action, makeAutoObservable, observable, runInAction } from "mobx"
import { moduleIds } from "@lib/appconst"
import appDataService from "@services/appDataService"
import unitTypeService from "@services/master-data/unitTypeService"
import viewService from "@services/master-data/viewService"
import customerSourceService from "@services/master-data/customerSourceService"
import accountTypeService from "@services/master-data/accountingData/accountTypeService"
import offsetAccountService from "@services/master-data/accountingData/offsetAccountService"
import salePolicyService from "@services/salePolicy/salePolicyService"
import contractInquiryService from "@services/contract/contractInquiryService"
import systemConfigurationService from "@services/system/systemConfigurationService"
import costCenterService from "@services/master-data/accountingData/costCenterService"
import groupService from "@services/master-data/groupService"
import propertyTypeService from "@services/master-data/propertyTypeService"
class AppDataStore {
  @observable isLoading!: boolean
  @observable countries!: any
  @observable nationality!: any
  @observable departments!: any

  @observable opportunityStatus!: any
  @observable unitTypes!: any
  @observable unitTypeChilds!: any
  @observable unitStatus!: any
  @observable leadSource!: any
  @observable documentTypes!: any

  @observable paymentStatus!: any

  // Project
  @observable propertyTypes!: any

  @observable facilities!: any
  @observable grades!: any

  @observable transportations!: any
  @observable clients: any[] = []
  @observable contacts: any[] = []
  @observable inquiryStatus: any[] = []
  @observable inquirySubStage: any[] = []
  @observable inquirySubStageByStage: any[] = []
  // CRM
  @observable sources!: any[]
  @observable potentialChannel!: any[]
  @observable carts!: any[]

  // Master data
  @observable townships: any = []
  @observable projects: any = []
  @observable units: any = []

  @observable towers: any = []
  @observable zones: any = []
  @observable floors: any = []
  @observable projectFacilities: any = []
  @observable unitFacilities: any = []
  @observable unitDesigns: any = []
  @observable listEmployee: any = []

  @observable listCartTemplateSms: any = []
  @observable listCartTemplateEmail: any = []
  @observable agencyMasters: any = []
  @observable listBookingStatus: any = []

  // Unit
  @observable facing: any = []
  @observable view: any = []

  //contract
  @observable listContract: any = []
  @observable listContractType: any = []
  @observable listPaymentProgress: any = []
  @observable listSalePolicy: any = []
  @observable listCompany: any = []

  @observable listPrintTemplate: any = []

  //accounting data
  @observable accountTypes: any = []
  @observable offsetAccountParents: any = []

  @observable listOffsetAccount: any = []
  @observable listCostCenter: any = []
  @observable listGroup: any = []

  constructor() {
    makeAutoObservable(this)
    // this.getDepartments({});
    this.carts = []
  }
  @action getInquirySourceAndStatus = async () => {
    const res = await appDataService.getInquirySourceAndStatus()
    this.inquiryStatus = res.filter((item) => item.code === "InquiryStatus")
    this.inquirySubStage = res.filter((item) => item.code === "InquiryStage")
  }

  @action getInquirySubStage = async (id) => {
    this.inquirySubStageByStage = this.inquirySubStage.filter(
      (item) => item.parentId === id
    )
  }

  @action getClients = async (keyword) => {
    this.clients = await appDataService.getClients(keyword)
  }
  @action getContacts = async (keyword) => {
    this.contacts = await appDataService.getContacts(keyword)
  }

  @action
  async getCountries(params) {
    const res = await appDataService.getCountries(params)

    this.countries = (res || []).map((item) => {
      item.phoneCodeName = `${item.countryCode} (+${item.phoneCode})`
      item.name = item.countryName
      item.label = item.countryName
      item.value = item.id
      item.isLeaf = false // for Cascader
      return item
    })
    this.nationality = (res || []).map((item) => {
      item.phoneCodeName = `${item.countryCode} (+${item.phoneCode})`
      item.name = item.nationalityName
      item.label = item.nationalityName
      item.value = item.id
      item.isLeaf = false // for Cascader
      return item
    })
  }

  @action
  async getDepartments(params) {
    this.departments = await appDataService.getDepartments(params)
  }

  @action
  async getDocumentType(params) {
    const res = await appDataService.getDocumentType(params)
    const rel = res.filter((item) => item.id !== 8)
    this.documentTypes = rel.map((item) => {
      return { id: item?.id, value: item?.id, label: item?.name }
    })
  }

  //PMH
  //Unit
  @action async GetListUnitStatus(keyword) {
    const res = await appDataService.GetListUnitStatus(keyword)
    this.unitStatus = res
  }

  @action async GetListLeadSource(keyword) {
    this.leadSource = await appDataService.GetListLeadSource(keyword)
  }
  //project
  @action async GetListPropertyType(keyword) {
    this.propertyTypes = await propertyTypeService.getList({ keyword })
  }

  // MasterData
  @action
  async getListUnitType(params?: any) {
    this.isLoading = true
    const result = await unitTypeService
      .getList(params)
      .finally(() => (this.isLoading = false))
    this.unitTypes = result
  }

  @action
  async getListUnitTypeChild(params?: any) {
    this.isLoading = true
    const result = await unitTypeService
      .getListChildren(params)
      .finally(() => (this.isLoading = false))
    this.unitTypeChilds = result
  }
  @action async getListTownShip(params?: any) {
    this.townships = await appDataService.GetListTownShip(params)
  }

  @action async getListProject() {
    const res = await appDataService.getListProject()
    this.projects = res.map((i) => {
      return {
        ...i,
        label: i.projectName,
      }
    })
  }
  @action async getListUnit(params?: any) {
    const res = await appDataService.getListUnit(params)
    this.units = res.map((i) => {
      return {
        ...i,
        label: i.unitName,
      }
    })
  }
  @action async getListTower() {
    this.towers = await appDataService.GetListTower()
  }

  @action async getListZone() {
    this.zones = await appDataService.GetListZone()
  }
  @action async getListFloor() {
    this.floors = await appDataService.GetListFloor()
  }

  @action async GetListUnitFacility() {
    this.unitFacilities = await appDataService.GetListUnitFacility()
  }
  @action async GetListUnitDesign() {
    this.unitDesigns = await appDataService.GetListUnitDesign()
  }

  @action async GetListProjectFacility() {
    this.projectFacilities = await appDataService.GetListProjectFacility()
  }

  @action async getListEmployee(params?: any) {
    const result = await appDataService.getListEmployee(params)
    runInAction(() => {
      this.listEmployee = result
    })
  }
  @action async getListCartTemplateEmail(moduleId?: number) {
    this.listCartTemplateEmail = await appDataService.getListCartTemplate({
      module: moduleId || moduleIds.cartEmail,
    })
  }
  @action async getListCartTemplateSms() {
    this.listCartTemplateSms = await appDataService.getListCartTemplate({
      module: moduleIds.cartSms,
    })
  }

  // CRM
  @action
  async getListSource() {
    const res = await customerSourceService.getList()
    this.sources = res
  }
  @action
  async getListPotentialChannel() {
    const res = await appDataService.getListPotentialChannel()
    this.potentialChannel = res
  }

  @action async GetListFacing() {
    this.facing = await appDataService.GetListFacing()
  }
  @action async GetListView() {
    this.view = await viewService.getList()
  }
  @action async getListCart(params?) {
    this.carts = await appDataService.GetListCart(params)
  }
  @action async getListAgencyMaster(params?) {
    this.agencyMasters = await appDataService.GetListAgencyMaster(params)
  }

  // Booking
  @action async getListBookingStatus(params?) {
    this.listBookingStatus = await appDataService.getListBookingStatus(params)
  }
  // company
  @action async getListCompany(params?) {
    const result = await appDataService.getListCompany(params)
    this.listCompany = result || []
  }
  // Contract
  @action async getListContractType(params?) {
    this.listContractType = await appDataService.getListContractType(params)
  }

  @action async getListPaymentProgress(params?) {
    this.listPaymentProgress = await appDataService.getListPaymentProgress(
      params
    )
  }
  @action async getListGroup(params?) {
    this.listGroup = await groupService.getList()
  }
  @action
  async getListContract() {
    const result = await contractInquiryService.getListContractComboBox()

    this.listContract = result?.map((i) => ({
      ...i,
      value: i.id,
      label: `${i.code} - ${i?.unitName}`,
    }))
  }

  @action async getListSalePolicy(params?) {
    this.listSalePolicy = await salePolicyService.getList(params)
  }
  @action async getListCostCenter() {
    this.listCostCenter = await costCenterService.getListForAdmin()
  }
  @action async getListOffsetAccount() {
    this.listOffsetAccount = await offsetAccountService.getListForAdmin()
  }
  @action async getListPrintingTemplate(params?) {
    this.listPrintTemplate =
      await systemConfigurationService.getListPrintingTemplate(params)
  }

  // Accounting Data
  @action async getListAccountType() {
    this.isLoading = true
    const result = await accountTypeService
      .getListForAdmin()
      .finally(() => (this.isLoading = false))

    this.accountTypes = result || []
  }
  @action async getListOffsetAcountParent() {
    this.isLoading = true
    const result = await offsetAccountService
      .getListForAdmin()
      .finally(() => (this.isLoading = false))

    this.offsetAccountParents =
      result
        ?.filter((i) => !i.parentId)
        ?.map((i) => ({ id: i.id, name: i.code, label: i.code })) || []
  }
}

export default AppDataStore

const appDataStoreInstance = new AppDataStore()
export { appDataStoreInstance }
